import React from "react";
import Lottie from 'lottie-react';
import TransactionLoaderGif from '../../assets/animation/loader.json';
import LoadingOverlay from "react-loading-overlay";

const TransactionLoader = ({ children, isActive, text }) => {
  return (
    <LoadingOverlay
      active={isActive}
      spinner={false}
      styles={{
        wrapper: (base) => ({
          ...base,
          height: isActive ? '100vh' : 'auto',
          overflow: isActive ? 'hidden' : 'visible',
        }),
        overlay: (base) => ({
          ...base,
          position: 'fixed',
          top: 0,
          left: 0,
          width: '100vw',
          height: '100vh',
          background: 'rgba(0, 0, 0, 0.7)',
          display: 'flex',
         
          justifyContent: 'center',
          alignItems: 'center',    
          zIndex: 9999,
          paddingTop: '80px',
        }),
        content: (base) => ({
          ...base,
          margin: '0',        
          width: '100%',      
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center'
        })
      }}
      text={
        <div style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center'
        }}>
          <div style={{ width: '300px', height: '300px' }}>
            <Lottie animationData={TransactionLoaderGif} loop={true} />
          </div>
          {text && (
            <div style={{
              color: 'white',
              fontSize: '1.2rem',
              marginTop: '-20px',
              fontWeight: '500'
            }}>
              {text}
            </div>
          )}
        </div>
      }
    >
      {children}
    </LoadingOverlay>
  );
};

export default TransactionLoader;